// client/buildify/embedding-schema.ts
import { AdornisFilter } from "@adornis/filter/AdornisFilter.js";
import { StringAspect } from "@adornis/filter/aspect-schemas/StringAspect.js";
import { runInsertNode } from "@adornis/html-based-buildify/client/helper/runInsertNode.js";
import { isNodeSelection } from "@adornis/html-based-buildify/client/util.js";
import { html } from "lit";
import { HTMLEmbedding } from "../../db/buildify/HTMLEmbedding.js";
import { WikiEntry } from "../../db/WikiEntry.js";
import "./embedding.js";
var getNewDefault = () => JSON.stringify(new HTMLEmbedding({}).toObject());
var EMBEDDING_KEY = "embedding";
var editor = (disallowedId) => {
  return ({ content, contentController, controllerBaseKeyPath, host }) => {
    return html`
      <x-flex space="sm">
        <x-entity-picker
          placeholder="Seite zum einbetten"
          clearable
          .options=${{
      class: WikiEntry,
      selectionSet: { title: 1 },
      filter: new AdornisFilter({
        searchFields: ["title"],
        aspects: [
          new StringAspect({
            fieldName: "_class",
            mode: "equals",
            value: WikiEntry._class
          }),
          ...disallowedId ? [
            new StringAspect({
              fieldName: "_id",
              mode: "regex",
              value: `^(?!${disallowedId}$)`
            })
          ] : []
        ]
      })
    }}
          .value=${contentController.document?.entryID}
          @value-picked=${(e) => {
      if (!contentController.document) {
        return;
      }
      contentController.document.entryID = !e.detail.value ? null : e.detail.value;
    }}
        >
        </x-entity-picker>
      </x-flex>
    `;
  };
};
var embedding = (disallowedId) => ({
  node: {
    name: EMBEDDING_KEY,
    schema: {
      draggable: true,
      atom: true,
      isolating: true,
      group: "block",
      attrs: {
        data: { default: getNewDefault() }
      },
      parseDOM: [
        {
          tag: "node-embedding",
          getAttrs(dom) {
            return {
              data: dom.getAttribute("data") ?? getNewDefault()
            };
          }
        }
      ],
      toDOM: (node) => {
        return ["node-embedding", { data: node.attrs.data, "no-content": "true" }];
      }
    }
  },
  menuItems: [
    {
      label: "Seite einbetten",
      icon: "place_item",
      run: (view) => runInsertNode(EMBEDDING_KEY, (state) => {
        return {
          content: [state.schema.nodes[EMBEDDING_KEY].create()]
        };
      })(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ],
  editor: editor(disallowedId)
});
export {
  embedding
};
